// Generated by scripts/build-ui-icons.mjs.
export { ClipboardText as default } from "../ui/glyphs-2";
